export const PavementMarkings = {
  xOffset: 0,
  yOffset: 0,
  pixels: [
    {
      x: 7,
      y: 5
    },
    {
      x: 7,
      y: 6
    },
    {
      x: 7,
      y: 7
    },
    {
      x: 7,
      y: 8
    },
    {
      x: 7,
      y: 9
    },
    {
      x: 7,
      y: 10
    },
    {
      x: 7,
      y: 11
    },
    {
      x: 8,
      y: 5
    },
    {
      x: 9,
      y: 5
    },
    {
      x: 10,
      y: 5
    },
    {
      x: 11,
      y: 6
    },
    {
      x: 11,
      y: 7
    },
    {
      x: 8,
      y: 8
    },
    {
      x: 9,
      y: 8
    },
    {
      x: 10,
      y: 8
    },
    {
      x: 13,
      y: 11
    },
    {
      x: 13,
      y: 10
    },
    {
      x: 13,
      y: 9
    },
    {
      x: 13,
      y: 8
    },
    {
      x: 13,
      y: 7
    },
    {
      x: 15,
      y: 5
    },
    {
      x: 14,
      y: 6
    },
    {
      x: 16,
      y: 6
    },
    {
      x: 17,
      y: 7
    },
    {
      x: 17,
      y: 8
    },
    {
      x: 17,
      y: 9
    },
    {
      x: 17,
      y: 10
    },
    {
      x: 17,
      y: 11
    },
    {
      x: 14,
      y: 9
    },
    {
      x: 15,
      y: 9
    },
    {
      x: 16,
      y: 9
    },
    {
      x: 19,
      y: 5
    },
    {
      x: 19,
      y: 6
    },
    {
      x: 19,
      y: 7
    },
    {
      x: 20,
      y: 8
    },
    {
      x: 20,
      y: 9
    },
    {
      x: 20,
      y: 10
    },
    {
      x: 21,
      y: 11
    },
    {
      x: 22,
      y: 10
    },
    {
      x: 22,
      y: 9
    },
    {
      x: 22,
      y: 8
    },
    {
      x: 23,
      y: 7
    },
    {
      x: 23,
      y: 6
    },
    {
      x: 23,
      y: 5
    },
    {
      x: 25,
      y: 5
    },
    {
      x: 26,
      y: 5
    },
    {
      x: 27,
      y: 5
    },
    {
      x: 28,
      y: 5
    },
    {
      x: 29,
      y: 5
    },
    {
      x: 25,
      y: 6
    },
    {
      x: 25,
      y: 7
    },
    {
      x: 25,
      y: 8
    },
    {
      x: 25,
      y: 9
    },
    {
      x: 25,
      y: 10
    },
    {
      x: 25,
      y: 11
    },
    {
      x: 26,
      y: 11
    },
    {
      x: 27,
      y: 11
    },
    {
      x: 28,
      y: 11
    },
    {
      x: 29,
      y: 11
    },
    {
      x: 26,
      y: 8
    },
    {
      x: 27,
      y: 8
    },
    {
      x: 28,
      y: 8
    },
    {
      x: 31,
      y: 11
    },
    {
      x: 31,
      y: 10
    },
    {
      x: 31,
      y: 9
    },
    {
      x: 31,
      y: 8
    },
    {
      x: 31,
      y: 6
    },
    {
      x: 31,
      y: 7
    },
    {
      x: 31,
      y: 5
    },
    {
      x: 32,
      y: 6
    },
    {
      x: 33,
      y: 7
    },
    {
      x: 33,
      y: 8
    },
    {
      x: 34,
      y: 6
    },
    {
      x: 35,
      y: 5
    },
    {
      x: 35,
      y: 6
    },
    {
      x: 35,
      y: 7
    },
    {
      x: 35,
      y: 8
    },
    {
      x: 35,
      y: 10
    },
    {
      x: 35,
      y: 11
    },
    {
      x: 35,
      y: 9
    },
    {
      x: 33,
      y: 9
    },
    {
      x: 37,
      y: 5
    },
    {
      x: 37,
      y: 6
    },
    {
      x: 37,
      y: 7
    },
    {
      x: 37,
      y: 8
    },
    {
      x: 37,
      y: 9
    },
    {
      x: 37,
      y: 10
    },
    {
      x: 37,
      y: 11
    },
    {
      x: 38,
      y: 5
    },
    {
      x: 39,
      y: 5
    },
    {
      x: 40,
      y: 5
    },
    {
      x: 41,
      y: 5
    },
    {
      x: 38,
      y: 11
    },
    {
      x: 39,
      y: 11
    },
    {
      x: 40,
      y: 11
    },
    {
      x: 41,
      y: 11
    },
    {
      x: 38,
      y: 8
    },
    {
      x: 39,
      y: 8
    },
    {
      x: 40,
      y: 8
    },
    {
      x: 43,
      y: 11
    },
    {
      x: 43,
      y: 10
    },
    {
      x: 43,
      y: 9
    },
    {
      x: 43,
      y: 7
    },
    {
      x: 43,
      y: 6
    },
    {
      x: 43,
      y: 5
    },
    {
      x: 43,
      y: 8
    },
    {
      x: 44,
      y: 7
    },
    {
      x: 45,
      y: 8
    },
    {
      x: 46,
      y: 9
    },
    {
      x: 47,
      y: 11
    },
    {
      x: 47,
      y: 10
    },
    {
      x: 47,
      y: 9
    },
    {
      x: 47,
      y: 8
    },
    {
      x: 47,
      y: 7
    },
    {
      x: 47,
      y: 6
    },
    {
      x: 47,
      y: 5
    },
    {
      x: 49,
      y: 5
    },
    {
      x: 50,
      y: 5
    },
    {
      x: 51,
      y: 5
    },
    {
      x: 52,
      y: 5
    },
    {
      x: 53,
      y: 5
    },
    {
      x: 51,
      y: 6
    },
    {
      x: 51,
      y: 7
    },
    {
      x: 51,
      y: 8
    },
    {
      x: 51,
      y: 9
    },
    {
      x: 51,
      y: 10
    },
    {
      x: 51,
      y: 11
    },
    {
      x: 11,
      y: 19
    },
    {
      x: 17,
      y: 22
    },
    {
      x: 14,
      y: 22
    },
    {
      x: 15,
      y: 22
    },
    {
      x: 16,
      y: 22
    },
    {
      x: 20,
      y: 18
    },
    {
      x: 21,
      y: 18
    },
    {
      x: 22,
      y: 18
    },
    {
      x: 20,
      y: 21
    },
    {
      x: 21,
      y: 21
    },
    {
      x: 22,
      y: 21
    },
    {
      x: 26,
      y: 21
    },
    {
      x: 33,
      y: 18
    },
    {
      x: 32,
      y: 24
    },
    {
      x: 33,
      y: 24
    },
    {
      x: 39,
      y: 22
    },
    {
      x: 43,
      y: 24
    },
    {
      x: 44,
      y: 24
    },
    {
      x: 45,
      y: 22
    },
    {
      x: 43,
      y: 18
    },
    {
      x: 44,
      y: 18
    },
    {
      x: 49,
      y: 18
    },
    {
      x: 50,
      y: 18
    },
    {
      x: 49,
      y: 21
    },
    {
      x: 50,
      y: 21
    },
    {
      x: 50,
      y: 24
    },
    {
      x: 49,
      y: 24
    },
    {
      x: 52,
      y: 19
    },
    {
      x: 52,
      y: 22
    },
    {
      x: 52,
      y: 23
    },
    {
      x: 51,
      y: 24
    },
    {
      x: 51,
      y: 18
    },
    {
      x: 48,
      y: 19
    },
    {
      x: 48,
      y: 20
    },
    {
      x: 48,
      y: 23
    },
    {
      x: 51,
      y: 21
    },
    {
      x: 46,
      y: 19
    },
    {
      x: 46,
      y: 22
    },
    {
      x: 46,
      y: 23
    },
    {
      x: 42,
      y: 19
    },
    {
      x: 42,
      y: 20
    },
    {
      x: 42,
      y: 21
    },
    {
      x: 42,
      y: 22
    },
    {
      x: 42,
      y: 23
    },
    {
      x: 45,
      y: 18
    },
    {
      x: 45,
      y: 24
    },
    {
      x: 40,
      y: 18
    },
    {
      x: 40,
      y: 19
    },
    {
      x: 40,
      y: 20
    },
    {
      x: 40,
      y: 21
    },
    {
      x: 40,
      y: 22
    },
    {
      x: 40,
      y: 23
    },
    {
      x: 40,
      y: 24
    },
    {
      x: 38,
      y: 21
    },
    {
      x: 37,
      y: 20
    },
    {
      x: 36,
      y: 18
    },
    {
      x: 36,
      y: 19
    },
    {
      x: 36,
      y: 20
    },
    {
      x: 36,
      y: 21
    },
    {
      x: 36,
      y: 22
    },
    {
      x: 36,
      y: 23
    },
    {
      x: 36,
      y: 24
    },
    {
      x: 34,
      y: 18
    },
    {
      x: 33,
      y: 19
    },
    {
      x: 33,
      y: 20
    },
    {
      x: 33,
      y: 21
    },
    {
      x: 33,
      y: 22
    },
    {
      x: 33,
      y: 23
    },
    {
      x: 34,
      y: 24
    },
    {
      x: 32,
      y: 18
    },
    {
      x: 30,
      y: 18
    },
    {
      x: 30,
      y: 24
    },
    {
      x: 29,
      y: 19
    },
    {
      x: 29,
      y: 23
    },
    {
      x: 28,
      y: 22
    },
    {
      x: 28,
      y: 20
    },
    {
      x: 27,
      y: 21
    },
    {
      x: 26,
      y: 18
    },
    {
      x: 26,
      y: 19
    },
    {
      x: 26,
      y: 20
    },
    {
      x: 26,
      y: 22
    },
    {
      x: 26,
      y: 23
    },
    {
      x: 26,
      y: 24
    },
    {
      x: 24,
      y: 19
    },
    {
      x: 24,
      y: 20
    },
    {
      x: 23,
      y: 18
    },
    {
      x: 23,
      y: 21
    },
    {
      x: 24,
      y: 24
    },
    {
      x: 23,
      y: 23
    },
    {
      x: 20,
      y: 19
    },
    {
      x: 20,
      y: 20
    },
    {
      x: 20,
      y: 22
    },
    {
      x: 20,
      y: 23
    },
    {
      x: 20,
      y: 24
    },
    {
      x: 22,
      y: 22
    },
    {
      x: 18,
      y: 20
    },
    {
      x: 18,
      y: 21
    },
    {
      x: 18,
      y: 22
    },
    {
      x: 18,
      y: 23
    },
    {
      x: 18,
      y: 24
    },
    {
      x: 17,
      y: 19
    },
    {
      x: 16,
      y: 18
    },
    {
      x: 15,
      y: 19
    },
    {
      x: 14,
      y: 20
    },
    {
      x: 14,
      y: 21
    },
    {
      x: 14,
      y: 23
    },
    {
      x: 14,
      y: 24
    },
    {
      x: 12,
      y: 24
    },
    {
      x: 12,
      y: 23
    },
    {
      x: 12,
      y: 22
    },
    {
      x: 12,
      y: 21
    },
    {
      x: 12,
      y: 19
    },
    {
      x: 12,
      y: 20
    },
    {
      x: 12,
      y: 18
    },
    {
      x: 10,
      y: 20
    },
    {
      x: 10,
      y: 21
    },
    {
      x: 10,
      y: 22
    },
    {
      x: 9,
      y: 19
    },
    {
      x: 8,
      y: 18
    },
    {
      x: 8,
      y: 19
    },
    {
      x: 8,
      y: 20
    },
    {
      x: 8,
      y: 21
    },
    {
      x: 8,
      y: 22
    },
    {
      x: 8,
      y: 23
    },
    {
      x: 8,
      y: 24
    }
  ]
};
